const NoItems = ({message='No items'}) => {
  return <p className="no-items">{message}</p>;
};

export default NoItems;
